import React, { useState } from "react";
import {
  FaAndroid,
  FaDesktop,
  FaGlobe,
  FaMobileAlt,
  FaShoppingCart,
  FaUserTie,
} from "react-icons/fa";
import { FaWarehouse } from "react-icons/fa6";
import Add_wharehouse from "../../../assets/Docs/wharehouse.png";

const Warehouses = () => {

  const [activeTab2, setActiveTab2] = useState("web");


  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];


  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => !tab.disabled && setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${
            activeState === tab.id
              ? "bg-[#1a9588] text-white shadow-md"
              : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
          } ${tab.disabled ? "opacity-50 cursor-not-allowed" : ""}`}
          disabled={tab.disabled}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );
  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">




      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaWarehouse className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Warehouses</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 sm:mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          {/* Seller Tag */}
          <span className="flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-green-200 transition">
            <FaUserTie className="text-green-600" />
            Seller
          </span>

          <span className=" flex items-center gap-2 bg-pink-100 text-pink-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-pink-200 transition">
            <FaShoppingCart className="text-pink-600" />
            Buyer
          </span>
        </div>

        <div className="flex flex-wrap gap-3">
          {/* Web Tag */}
          <span className="flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-blue-200 transition">
            <FaGlobe className="text-blue-600" />
            Web
          </span>

          {/* Android Tag */}
          <span className="flex items-center gap-2 bg-green-100 text-green-700 px-4 py-2 rounded-full font-semibold text-sm shadow-sm hover:bg-green-200 transition">
            <FaAndroid className="text-green-600" />
            Android
          </span>
        </div>
      </div>
      <p className="text-start mb-6 text-gray-600 text-gray-300">
        You can specify the warehouse where each product size is kept. The
        easiest way to do this is by including the information in the Excel file
        used for product imports. Warehouse details are also shown in the
        Itemised Quantity Report and Projection Report, helping you fulfill
        orders more efficiently.
      </p>
      {/* <div className="text-start">
                <h3 className="text-2xl text-gray-500 mb-2">Adding / Updating Products</h3>
                <p className="text-gray-600 mb-6">
                    Go to the 'Products' section & click on 'Add New'. Fill in the fields and click 'Save'. The new product is saved to the database.
                </p>
            </div> */}

      <div>
        <div className="text-start">
          <h3 className="text-2xl text-gray-500 mb-2">
            Add / Update Warehouse
          </h3>
          <p className="text-gray-600 mb-6">
            Warehouses can be managed in the 'Settings' section. To create a new
            warehouse, click 'Add New' and enter the warehouse name.
          </p>
        </div>
        {renderTabs(activeTab2, setActiveTab2)}
        <div className="rounded-lg p-2 sm:p-4 flex justify-start">
          <img
            src={Add_wharehouse}
            alt={`${activeTab2} view`}
            className="rounded-lg border max-w-full h-auto max-h-[80vh] object-contain"
          />
        </div>
      </div>

      <div className="bg-red-100 text-red-800 p-4 rounded-lg border border-red-300 text-start">
        Warehouse once defined cannot be deleted.
      </div>

      <div className="bg-yellow-100 text-yellow-800 p-4 rounded-lg border border-yellow-300 text-start my-4">
        Use the toggle to show or hide a warehouse for all products. The changes
        will only be applied after you publish your product data.
      </div>
    </div>
  );
};

export default Warehouses;
